import {ReactNode} from "react";

export const formatMultiLineText = (lines: string[], lineClassName: string): ReactNode => {
    if (!lines.length || lines.every(line => !line)) {
        return <span>-</span>;
    }
    return (
        <>
            {lines.map((line, index) => {
                return (
                    <span key={index} className={lineClassName}>
                        {line}
                    </span>
                );
            })}
        </>
    );
};